import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./DropdownPortal.css";

export type DropdownPosition = {
  top: number;
  left: number;
};

type DropdownPortalProps = {
  position: DropdownPosition;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  minWidth?: number;
};

export const DropdownPortal: React.FC<DropdownPortalProps> = ({
  position,
  onClose,
  children,
  className = "",
  minWidth = 200,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const dropdownContent = (
    <div
      className={`dropdown-portal ${className}`}
      ref={menuRef}
      style={{
        top: position.top,
        left: position.left,
        minWidth: minWidth,
      }}
    >
      {children}
    </div>
  );

  return createPortal(dropdownContent, document.body);
};
